import React from 'react';
import classNames from 'classnames';
import InfoCard from '../InfoCard';
import { ContentLayout, BentoConfig, ConceptBlockProps } from '../../types/types';
import './ConceptBlock.scss';

/**
 * ConceptBlock component for displaying structured content in the AIAnalysis module
 * Follows a consistent layout with title, optional description, and optional content sections
 */
export const ConceptBlock: React.FC<ConceptBlockProps> = ({
  title,
  icon,
  description,
  children,
  contentLayout = 'list',
  bentoConfig,
  className,
}) => {
  // Generate CSS class for the content layout
  const contentLayoutClass = `concept-block__content--${contentLayout}`;

  // Generate CSS grid template areas for bento layout if provided
  const gridStyle =
    contentLayout === 'bento' && bentoConfig?.areas
      ? {
          gridTemplateAreas: `"${bentoConfig.areas.join('" "')}"`,
          gridTemplateColumns: `repeat(${bentoConfig.columns || 2}, 1fr)`,
        }
      : {};

  return (
    <div className={classNames('concept-block', className)}>
      {/* Title section - only render if title or description exists */}
      {(title || description) && (
        <div className="concept-block__header">
          {title && (
            <div className="concept-block__title">
              {icon && <div className="concept-block__icon">{icon}</div>}
              {title}
            </div>
          )}
          {/* Description section using InfoCard */}
          {description && (
            <div className="concept-block__description">
              <InfoCard message={description} isACard={false} showInfoIcon={false} />
            </div>
          )}
        </div>
      )}

      {/* Content section with configurable layout */}
      {children && (
        <div className={classNames('concept-block__content', contentLayoutClass)} style={gridStyle}>
          {children}
        </div>
      )}
    </div>
  );
};

export default ConceptBlock;
